import React from 'react';
import LikeButton from './LikeButton';
import CommentButton from './CommentButton';
import SaveButton from './SaveButton';
import './RecipeActions.css';

function RecipeActions({ recipeId, initialLikes, likedUsers }) {
    return (
        <div className="recipe-actions">
            <LikeButton
                recipeId={recipeId}
                initialCount={initialLikes}
                likedUsers={likedUsers}
            />
            <CommentButton recipeId={recipeId} />
            <SaveButton recipeId={recipeId} />
        </div>
    );
}

export default RecipeActions;